import {
	defAction
}from "../../../../helpers/defaultAction"
import {
	reCountryConstants
}from "./constants"
import api from './api'

export const reCountryActions = {
	getPaged,
	getPagedAudit,
	getPagedAll,
	getList,
	create,
	remove,
	update,
	restore,
	clear
}

function getPaged(values){
	const dispatchObj = {
		constants : reCountryConstants.GetPaged,
		service   : {
			func   : api.getPaged,
			params : values
		}
	}
	return defAction(dispatchObj)
}
function getPagedAudit(values){
	const dispatchObj = {
		constants : reCountryConstants.GetPagedAudit,
		service   : {
			func   : api.getPagedAudit,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getPagedAll(values){
	const dispatchObj = {
		constants : reCountryConstants.GetPagedAll,
		service   : {
			func   : api.getPagedAll,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getList(values){
	const dispatchObj = {
		constants : reCountryConstants.GetList,
		service   : {
			func   : api.getList,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function create(values){
	const dispatchObj = {
		constants : reCountryConstants.Create,
		service   : {
			func   : api.create,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function remove(values){
	const dispatchObj = {
		constants : reCountryConstants.Delete,
		service   : {
			func   : api.delete,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function restore(values){
	const dispatchObj = {
		constants : reCountryConstants.Restore,
		service   : {
			func   : api.restore,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function update(values){
	const dispatchObj = {
		constants : reCountryConstants.Update,
		service   : {
			func   : api.update,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function clear(){
	return (dispatch) => dispatch({
		type: reCountryConstants.CLEAR
	})
}